import React from "react";
import Selector from "../../../Selector";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";

import useStyles from "../../style";

export function FilterAssignOnValidate({
  mainGroup,
  filterAssignOnValidate,
  setAssignOnValidate,
  action
}) {

  const classes = useStyles();

  const filters = [
    { value: 'all', label: 'Todas' },
    { value: 'my_assigned', label: 'Minhas' },
    { value: 'assigned_to_all', label: 'Com responsável' },
    { value: 'not_assigned', label: 'Sem responsável' }
  ];

  return action.indexOf("validar-documentos") !== -1 &&
  ["support", "backoffice"].indexOf(mainGroup) !== -1 && (
    <Grid
      item
      xs={12}
      sm={12}
      md={2}
      lg={2}
      className={classes.assignFilter}
    >
      <Selector
        options={filters}
        placeholder="Selecione uma opção"
        data-cy="tabHeader-filterAssin-select"
        id="tabHeader-filterAssin-select"
        label='Responsável'
        width='250px'
        isClearable
        isMulti
        value={filterAssignOnValidate}
        onChange={setAssignOnValidate}
        isOptionDisabled={(option) =>
          {
            if (filterAssignOnValidate.length === 0) {
              return false;
            }

            if(filterAssignOnValidate.some(selectedOption => selectedOption.value === 'all')) {
              if (option.value !== 'all') {
                return true;
              }
            } else {
              if (option.value === 'all') {
                return true;
              }
            }
          }
       }
      />
    </Grid>
  )
}

const mapState = (state) => ({
  filterAssignOnValidate: state.loadingOrders.filterAssignOnValidate
});

const mapDispatch = (dispatch) => ({
  setAssignOnValidate: (payload) => dispatch.loadingOrders.setAssignFilterOnValidate(payload)
});

export default connect(mapState, mapDispatch)(FilterAssignOnValidate);
